/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import {
	ColumnDirective,
	ColumnsDirective,
	Filter,
	GridComponent,
	Inject,
	Page,
	Search,
	Sort,
	Toolbar,
} from "@syncfusion/ej2-react-grids";
import { useEffect, useState, useContext } from "react";

import { Link, useOutletContext } from "react-router-dom";

import { CountryBrandApplication } from "../../domain/CountryBrandApplication";

import { CountryBrandApplicationApiRepository } from "../../infrastructure/CountryBrandApplicationApiRepository";
import { setComponentsCulture } from "../../translations/syncfusion.translate";
import { Login } from "./Login";
import { UserContext } from "../../context/UserContext";
import { ToastUtility } from "@syncfusion/ej2-react-notifications";

const repository = new CountryBrandApplicationApiRepository();

setComponentsCulture("es");

function Admin() {
	const [applications, setApplications] = useState<CountryBrandApplication[]>([]);
	const [setShowLoader] = useOutletContext();

	const { user, setUser } = useContext(UserContext);

	useEffect(
		function () {
			if (user) {
				setShowLoader(true);
				repository
					.getAll()
					.then(function (data) {
						if (JSON.stringify(data[0]) === "{}") {
							setUser(null);
							localStorage.removeItem("userToken");
						}
						setApplications(data);
					})
					.catch(function (error) {
						console.error(error);
						ToastUtility.show(
							"Hubo un problema con el proceso de su solicitud.<br>Intente nuevamente en un minuto.",
							"Error",
							8000
						);
					})
					.finally(function () {
						setShowLoader(false);
					});
			} else {
				setShowLoader(false);
			}
		},
		[user]
	);

	async function handleClick(application: CountryBrandApplication) {
		//const app = applications.find((e)=> e.id === application.id)
		const app = await repository.getByID(application.id); // Se agrego porque da error al si el objeto que se envia es de applications
		repository.update({
			...app,
			id: application.id,
			isCompleted: !application.isCompleted,
		});
		setApplications((prevValue) => {
			return prevValue.map((app) =>
				app.id === application.id ? { ...app, isCompleted: !app.isCompleted } : { ...app }
			);
		});
	}

	const applicationsList = applications.map((application) => {
		const { applicantCompanyName, id, isCompleted, uuid } = application;
		const createdDate = new Date(application.created);

		return { applicantCompanyName, createdDate, id, isCompleted, uuid };
	});

	if (!user) {
		return <Login />;
	}

	return (
		<div className="step-page" id="admin">
			<div className="applications-grid">
				<GridComponent
					dataSource={applicationsList}
					allowPaging={true}
					allowFiltering={true}
					allowSorting={true}
					filterSettings={{
						type: "Excel",
					}}
					pageSettings={{ pageSize: 20 }}
					searchSettings={{
						fields: ["applicantCompanyName"],
						operator: "contains",
						ignoreAccent: true,
						ignoreCase: true,
					}}
					toolbar={["Search"]}
				>
					<ColumnsDirective>
						<ColumnDirective field="id" visible={false} isPrimaryKey={true} />
						<ColumnDirective field="isComleted" visible={false} />
						<ColumnDirective
							field="applicantCompanyName"
							headerText="Nombre"
							template={({ applicantCompanyName, id }) => (
								<Link to={`/${id}`}>{applicantCompanyName}</Link>
							)}
						/>
						<ColumnDirective field="uuid" headerText="Código de solicitud" />
						<ColumnDirective
							field="createdDate"
							headerText="Fecha de creación"
							format="dd/MM/yyyy"
							type="date"
						/>
						{applications.length > 0 && (
							<ColumnDirective
								field="actions"
								headerText="Acciones"
								template={(props) => (
									<button
										style={{ width: "160px" }}
										className={`e-btn ${props.isCompleted ? "e-warning" : "e-success"}`}
										type="button"
										onClick={() => handleClick(props)}
									>
										{props.isCompleted ? "Abrir solicitud" : "Cerrar solicitud"}
									</button>
								)}
								allowFiltering={false}
							/>
						)}
					</ColumnsDirective>
					<Inject services={[Filter, Page, Search, Sort, Toolbar]} />
				</GridComponent>
			</div>
		</div>
	);
}

export { Admin };
